import { useEffect } from 'react'

// Calls `onScroll` the moment the user starts scrolling the page while `isActive`.
export const useCollapseOnScroll = (isActive: boolean, onScroll: () => void) => {
  useEffect(() => {
    if (!isActive) return undefined

    window.addEventListener('scroll', onScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [isActive, onScroll])
}
